import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const AddAfDialogBody = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t('jurisdictionArea.form.note')}
    </Fragment>
  );
};

export default AddAfDialogBody;
